import {
  AlertTypesPayload,
  NotificationSettings,
  NotificationSettingsPayload,
  NotificationSubscriptions,
  SubscriptionsPayload,
} from "entities/notifications";
import { GET, POST, PUT } from "utils/http";

const baseUrl = "/api/users";

export const getNotificationSettings = (userId: number) =>
  GET<NotificationSettings>(`${baseUrl}/${userId}/notification-settings`);

export const saveNotificationSettings = (userId: number, body: NotificationSettingsPayload) =>
  PUT<NotificationSettingsPayload>(`${baseUrl}/${userId}/notification-settings`, body);

export const setAlertTypes = (userId: number, body: AlertTypesPayload) =>
  PUT<AlertTypesPayload>(`${baseUrl}/${userId}/notification-settings/alert-types`, body);

export const getSubscriptions = (userId: number) =>
  GET<NotificationSubscriptions>(`${baseUrl}/${userId}/notification-subscriptions`);

export const saveSubscriptions = (userId: number, body: SubscriptionsPayload) =>
  PUT<SubscriptionsPayload>(`${baseUrl}/${userId}/notification-subscriptions`, body);

export const sendWhatsappCode = (userId: number, phone: string) =>
  POST<{ phone: string }, void>(`${baseUrl}/${userId}/notification-settings/whatsapp/send-code`, { phone });

export const verifyWhatsappCode = (userId: number, phone: string, code: string) =>
  POST<{ phone: string; code: string }, NotificationSettings>(
    `${baseUrl}/${userId}/notification-settings/whatsapp/verify-code`,
    { phone, code },
  );
